import {Component} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";

@Component({
  selector: 'app-digital-handshakes',
  templateUrl: './digital-handshakes.component.html',
  styleUrls: ['./digital-handshakes.component.scss', './digital-handshakes-media.component.scss']
})
export class DigitalHandshakesComponent {


  currentLang: string = '';

  constructor(public translate: TranslateService) {
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  protected readonly Language = Language;
}
